import * as React from "react";
import styled, { css } from "../../../styled/index";
import { CS } from "../../../styles/index";
const ClickOutComponent = require("react-onclickout");
export const Wrapper = styled("div") `
  position: relative;
`;
export const ChildContent = styled("div") `
  cursor: pointer;
`;
export const Dropdown = styled("div") `
  position: absolute;
  display: ${({ active }) => active ? "block" : "none"};
  height: auto;
  min-width: ${({ width }) => width ? `${width}px` : "100px"};
  width: ${({ width }) => width ? `${width}px` : "100%"};
  border-radius: 5px;
  background: ${({ theme }) => theme.box.background};
  color: ${({ theme }) => theme.box.text};
  ${CS.shadow.heavy.one};
  z-index: 12;
  ${({ direction, offset }) => direction === "top" ? css `
    bottom: calc(100% + ${offset || "4"}px);
  ` : css `
    top: calc(100% + ${offset || "4"}px);
  `}
  ${({ flow, right }) => flow === "left" ? css `
    right: ${right ? right : 0}px;
  ` : css `
    left: 0;
  `}
	${({ modal }) => modal ?
    `
	position: fixed;
	width: 100%;
	min-width: 100%;
	top: 0;
	`
    : null}
`;
export const Content = styled("div") `
  display: flex;
  flex-direction: column;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
`;
export class DropDown extends React.Component {
    clickOutActive = false;
    constructor(props) {
        super(props);
        this.state = {};
    }
    onClickOut = () => {
        if (this.props.active && this.clickOutActive) {
            this.props.close();
        }
    };
    componentDidUpdate() {
        setTimeout(() => {
            this.clickOutActive = this.props.active;
        }, 100);
    }
    render() {
        const { active, open, content, children, direction, flow, width, offset, right, modal } = this.props;
        return (React.createElement(Wrapper, null,
            React.createElement(ChildContent, { onClick: open }, children),
            React.createElement(ClickOutComponent, { onClickOut: this.onClickOut },
                React.createElement(Dropdown, { active: active, direction: direction, flow: flow, width: width, offset: offset, right: right, modal: modal },
                    React.createElement(Content, null, content)))));
    }
}
//# sourceMappingURL=index.js.map